import React from "react";

interface BigNumberProps {
  onClick: () => void;
}

const BigNumber = ({ onClick }: BigNumberProps) => (
  <button
    className="hero__big-number"
    type="button"
    aria-haspopup="dialog"
    aria-controls="hero-fact-modal"
    aria-label="A hidden door. Open for a random fact about advertising, behavioural science, innovation or psychology."
    data-hint="Go on, click it"
    onClick={onClick}
  >
    42
  </button>
);

export default BigNumber;
